import settings from "../settings";

const roundingMethod = (num) => {
  if (num === null) return 0;
  var re = new RegExp('^-?\\d+(?:.\\d{0,' + (settings.logDecimals || -1) + '})?');
  return +num.toString().match(re);
};

export default roundingMethod;
